import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'MyTypes';
import Tabs from '../Tabs/Tabs';
import Sidebar from '../../../Filter/components/Sidebar/Sidebar';
import List from '../List/List';
import styles from './ListView.module.scss';
import { activeCurriculumTypeSelector } from '../../../AppConfig/appConfigSelectors';
import { activeCTSlugSelector } from '../../listSelectors';

const mapStateToProps = (state: RootState) => ({
    activeCurriculumType: activeCurriculumTypeSelector(state),
    activeCTSlug: activeCTSlugSelector(state),
});

type Props = ReturnType<typeof mapStateToProps>;

const ListView: React.FC<Props> = ({ activeCurriculumType }) => {
    if (!activeCurriculumType) {
        return null;
    }

    return (
        <main className={styles.listView}>
            <div className={'container'}>
                <Tabs />
                <section className={styles.bodyContainer}>
                    <Sidebar activeCurriculumType={activeCurriculumType} />
                    <List activeCurriculumType={activeCurriculumType} />
                </section>
            </div>
        </main>
    );
};

export default connect(mapStateToProps)(ListView);
